import React from 'react'
import {Router, RouteComponentProps} from '@reach/router'

import Home from './Home'
import Products from './Products'
import ProductDetailsPage from './Products/ProductDetailsPage'
import Categories from './Products/ProductCategories'
import Registration from './Registration'
import Login from './Login'
import Cart from './Cart'
import UserSettings from './user-settings/UserSettings'
import OrderHistory from './Orders/OrderHistory'
import OrderDetailsPage from './Orders/OrderDetailsPage'
import CompanyRequestForm from './user-settings/CompanyRequestForm'
import {useAuth} from '../contexts/UserContext'
import {Navigation, Loader} from './layout'


interface RouteWrapperProps extends RouteComponentProps {
  children: React.ReactNode
}

function UserRoutes({children}: RouteWrapperProps) {
  const {authToken, user, userLoading, userCompaniesLoading} = useAuth()

  return <>
    <Navigation />
    {(userLoading || userCompaniesLoading) ? (
      <Loader />
    ) : <>
      {(authToken && user) ? children : (
        <Login />
      )}
    </>}
  </>
}


function CompanyRoutes({children}: RouteWrapperProps) {
  const {userCompanies} = useAuth()

  return <>
    {!userCompanies?.length ? (
      <CompanyRequestForm />
    ) : children}
  </>
}


export default function App() {
  return (
    <Router>
      <Home path="/" />
      <Registration path="/skraning/" />
      <Login path="/innskraning/" />

      <UserRoutes default>
        <CompanyRoutes default>
          <Categories path="/verslun/" />
          <Products path="/verslun/vorur/" />
          <ProductDetailsPage path="/verslun/vorur/:slug/" />
          <Cart path="/verslun/karfa/" />
        </CompanyRoutes>

        <UserSettings path="/verslun/stillingar/" />
        <OrderHistory path="/verslun/pantanir/" />
        <OrderDetailsPage path="/verslun/pantanir/:token/" />
      </UserRoutes>
    </Router>
  )
}
